import { IconButton, TableCell, TableRow, useTheme } from '@mui/material'
import React from 'react'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import { ContractorType } from '../../services/api/sharedTypes/Contractor'
import { NotPaidContractorsRow } from './tables/NotPaidContractorsTable'
import TableButtonOpen from '../../components/table/TableButtonOpen'
import { RouteConstants } from '../../navigation/navigation-types'
import PayContractorDialog from './PayContractorDialog'
import CustomTableCell from '../../components/common/CustomTableCell'
import { getNumberRoundedInFormattedString } from '../../utils/global-utils'

interface CollapsibleTableRowForContractorsProps {
    tableRowValues: NotPaidContractorsRow[]
    payContractor: (contractorId: string, eventId: string) => void
}

const CollapsibleTableRowForContractors: React.FC<CollapsibleTableRowForContractorsProps> = ({
    tableRowValues,
    payContractor,
}: CollapsibleTableRowForContractorsProps) => {
    const theme = useTheme()
    const [open, setOpen] = React.useState(false)

    const handleMultiplePayments = () => {
        tableRowValues.map((row) => payContractor(row.contractorId, row.eventId))
    }

    return (
        <>
            <TableRow tabIndex={-1} style={{ cursor: 'pointer' }} onClick={() => setOpen(!open)}>
                <CustomTableCell style={{ fontWeight: 700 }} maxWidth={350} isText>
                    <IconButton style={{ marginRight: theme.spacing(3) }} size='small' onClick={() => setOpen(!open)}>
                        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                    </IconButton>
                    Klienti
                </CustomTableCell>

                <CustomTableCell isText style={{ fontWeight: 700 }}>
                    {tableRowValues.length} Události
                </CustomTableCell>
                <CustomTableCell style={{ fontWeight: 700 }} isText>
                    {tableRowValues[0].contractorType === ContractorType.Brigadier ? 'Brigádník' : 'Dopravce'}
                </CustomTableCell>
                <CustomTableCell style={{ fontWeight: 700 }} isText>{tableRowValues[0].contractorName}</CustomTableCell>
                <TableCell />
                <CustomTableCell style={{ fontWeight: 700 }} align='right'>{getNumberRoundedInFormattedString(tableRowValues.reduce((acc, curr) => acc + curr.costs, 0))}</CustomTableCell>
                <CustomTableCell align='right' width={200}>
                    <div style={{ paddingRight: theme.spacing(4) }} >
                        <PayContractorDialog onContractorPaid={handleMultiplePayments} dialogType='multiple' />
                    </div>
                </CustomTableCell>
            </TableRow >
            {open &&
                tableRowValues.map((row) => (
                    <TableRow
                        hover
                        tabIndex={-1}
                        key={row.eventId}
                        style={{
                            backgroundColor: theme.palette.grey[50],
                        }}
                    >
                        <CustomTableCell isText maxWidth={350} route={RouteConstants.clients + '/' + row.clientId} >
                            <div style={{ paddingLeft: 50 }} >
                                {row.clientName}
                            </div>
                        </CustomTableCell>
                        <CustomTableCell
                            isText
                            style={{ cursor: 'pointer', paddingLeft: '14px' }}
                            route={RouteConstants.events + '/' + row.eventId}
                        >
                            {row.eventName}
                        </CustomTableCell>

                        <CustomTableCell style={{ cursor: 'pointer' }} route={RouteConstants.events + '/' + row.eventId} isText>
                            {row.contractorType === ContractorType.Brigadier ? 'Brigádník' : 'Dopravce'}
                        </CustomTableCell>
                        <CustomTableCell
                            isText
                            route={RouteConstants.workersAndCarriers + '/' + row.contractorId}
                            style={{ cursor: 'pointer' }}
                        >
                            {row.contractorName}
                        </CustomTableCell>
                        <CustomTableCell style={{ cursor: 'pointer' }} route={RouteConstants.events + '/' + row.eventId} align='right'>
                            {getNumberRoundedInFormattedString(row.costs)}
                        </CustomTableCell>
                        <CustomTableCell
                            center
                            style={{ cursor: 'pointer' }}
                            route={RouteConstants.events + '/' + row.eventId}
                        ></CustomTableCell>
                        <CustomTableCell align='right' width={200}>
                            <PayContractorDialog onContractorPaid={() => payContractor(row.contractorId, row.eventId)} />
                            <TableButtonOpen route={RouteConstants.events} id={row.eventId} />
                        </CustomTableCell>
                    </TableRow>
                ))
            }
        </>
    )
}

export default CollapsibleTableRowForContractors
